var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconDashboard = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16.494,
  height: 11.999,
  viewBox: "0 0 16.494 11.999",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Group_1194",
  "data-name": "Group 1194",
  transform: "translate(-19.075 -161.333)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_278",
  "data-name": "Group 278",
  transform: "translate(-718.295 -384.483)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_202",
  "data-name": "Path 202",
  d: "M742.069,556.839l-3.758,3.03a.323.323,0,0,0-.12.251v3.515a.323.323,0,0,0,.323.323h3.758a.323.323,0,0,0,.323-.323V557.09a.323.323,0,0,0-.526-.251Zm-.12,6.474h-3.112v-3.038l3.112-2.51Z",
  transform: "translate(-0.461 -6.144)",
  fill: "#173a6d"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_203",
  "data-name": "Path 203",
  d: "M751.738,552.4l-.969.606a.323.323,0,0,0-.152.274v7.879a.323.323,0,0,0,.323.323H754.7a.323.323,0,0,0,.323-.323v-5.576a.323.323,0,0,0-.089-.223l-2.788-2.909A.323.323,0,0,0,751.738,552.4Zm2.636,8.436h-3.112v-7.377l.6-.372,2.516,2.626Z",
  transform: "translate(-7.431 -3.666)",
  fill: "#173a6d"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_204",
  "data-name": "Path 204",
  d: "M765.637,554l-2.463,2.463a.227.227,0,0,0-.066.16v5.521a.226.226,0,0,0,.227.226H765.8a.226.226,0,0,0,.226-.226v-7.985a.226.226,0,0,0-.386-.16Zm-.066,7.919H763.56v-5.2l2.011-2.011Z",
  transform: "translate(-14.438 -4.552)",
  fill: "#173a6d"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_205",
  "data-name": "Path 205",
  d: "M753.317,545.888l-5.33,3.919-3.1-3.247a.383.383,0,0,0-.46-.059l-6.886,4.79c-.4.277-.019.935.383.655l6.644-4.622,3.107,3.253a.382.382,0,0,0,.46.06l5.567-4.093C754.09,546.256,753.711,545.6,753.317,545.888Z",
  fill: "#173a6d"
})))));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconDashboard, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon_dashboard.39c60959.svg";
export { ForwardRef as ReactComponent };